import React from 'react';
import Downshift from 'downshift';
import { getFilteredItems, stringifyItem } from '../common/helpers';
import { StyledWrapper, Icon, SearchIcon } from '../search-dropdown.style';
import {
    StyledMobileInput,
    StyledMobileMenu,
    StyledMobileItem,
    StyledHeaderItem,
    StyledSubHeaderItem,
} from './mobile-select.style';
import { CrossButton } from '../common/controller-buttons';
import { MenuHeaderItems } from '../common/menu-header-items';
import { IItem, ISelectProps } from '../common/interface';
import { DropdownItem } from '../common/dropdown-item';

interface ISelectBox extends ISelectProps {
    allHeadingItem: IItem;
    isModalOpen: boolean;
}

export const SelectBox = ({
    placeholder,
    items,
    onSelectHandler,
    allHeadingItem,
    heading,
    stateReducer,
    selectedItem,
    isModalOpen,
}: ISelectBox) => {
    const focusRef = React.createRef<HTMLInputElement>();

    React.useEffect(() => {
        // if (isModalOpen && focusRef.current) {
        //     focusRef.current.focus();
        // }
        if (!isModalOpen && focusRef.current) {
            focusRef.current.blur();
        }
    }, [isModalOpen, focusRef]);

    return (
        <Downshift
            id="search autocomplete"
            onSelect={onSelectHandler}
            itemToString={(item) => {
                if (typeof item === 'string') return item;
                else if (item === null || item === undefined) return '';
                return stringifyItem(item);
            }}
            stateReducer={stateReducer}
            {...(selectedItem !== undefined && { selectedItem })}
        >
            {({
                getInputProps,
                getMenuProps,
                getItemProps,
                isOpen,
                clearSelection,
                inputValue,
                highlightedIndex,
                selectedItem,
            }) => (
                <div>
                    <StyledWrapper>
                        <Icon>
                            <SearchIcon />
                        </Icon>
                        <StyledMobileInput
                            ref={focusRef}
                            aria-label={`select ${heading}`}
                            {...getInputProps({ isOpen, placeholder })}
                        />
                        {selectedItem ? (
                            <CrossButton
                                onClickHandler={clearSelection}
                                ariaLabel="clear selection"
                            />
                        ) : null}
                    </StyledWrapper>
                    <StyledMobileMenu {...getMenuProps()}>
                        <>
                            {!inputValue && (
                                <MenuHeaderItems
                                    highlightedIndex={highlightedIndex}
                                    getItemProps={getItemProps}
                                    allHeadingItem={allHeadingItem}
                                    selectedItem={selectedItem}
                                    heading={heading}
                                    menuItems={items.top}
                                    inputValue={inputValue}
                                    ItemComponent={StyledMobileItem}
                                    HeaderItemComponent={StyledHeaderItem}
                                    SubHeaderItemComponent={StyledSubHeaderItem}
                                />
                            )}
                            {getFilteredItems(inputValue as string, items.all).map(
                                (item, index) => {
                                    const offsetIndex =
                                        index +
                                        (!inputValue
                                            ? getFilteredItems(inputValue, items.top).length + 1
                                            : 0);
                                    return (
                                        <DropdownItem
                                            key={offsetIndex}
                                            index={offsetIndex}
                                            highlightedIndex={highlightedIndex}
                                            getItemProps={getItemProps}
                                            item={item}
                                            selectedItem={selectedItem}
                                            ItemComponent={StyledMobileItem}
                                        />
                                    );
                                },
                            )}
                        </>
                    </StyledMobileMenu>
                </div>
            )}
        </Downshift>
    );
};
